import { API } from '@/shared/api/modules';
import type { GetRevenueRequestDto } from '@/shared/api/modules/facilities';
import { queryOptions } from '@tanstack/react-query';

export const getRevenueQueryOptions = (params: GetRevenueRequestDto) =>
  queryOptions({
    queryKey: ['revenue', params],
    queryFn: async ({ signal }) => {
      const response = await API.facilities.getRevenue(params, {
        signal,
      });

      return response;
    },
    enabled: !!params.from && !!params.to,
  });
